module.exports = __webpack_public_path__ + "media/images/hitfun/sample.orglogo-49deec5396012faa0d67f5f8b27c4dd3.png";